const fetchWidgetData = async (
  cmsUrl: string,
  widgetName: string,
  locale: string,
): Promise<PageListResponse> => {
  const response = await fetch(
    `${cmsUrl}/api/pages?populate[0]=components,components.items&filters[slug][$eq]=${widgetName}&locale=${locale}`,
  );

  if (!response.ok) {
    throw new Error(`Error: ${response.status}`);
  }

  return await response.json();
};

const DEFAULT_APP_LOCALE = "en";

export const getWidgetCMSData = async (
  cmsUrl: string,
  widgetName: string,
  locale: string,
) => {
  try {
    const resp = await fetchWidgetData(cmsUrl, widgetName, locale);

    if (!resp?.data?.length) {
      throw new Error(
        `Empty CMS data for widget "${widgetName}" with lang ${locale}`,
      );
    }

    return resp.data?.[0]?.attributes?.components;
  } catch {
    if (locale.toLowerCase() === DEFAULT_APP_LOCALE) {
      throw new Error(`Failed to load CMS data for widget "${widgetName}"`);
    }

    const resp = await fetchWidgetData(cmsUrl, widgetName, DEFAULT_APP_LOCALE);

    return resp.data?.[0]?.attributes?.components;
  }
};

export interface PageListResponse {
  data?: Array<PageListResponseDataItem>;
  meta?: {
    pagination?: {
      page?: number;
      pageSize?: number;
      pageCount?: number;
      total?: number;
    };
  };
}

export interface PageListResponseDataItem {
  attributes?: Page;
  id?: number;
}

export interface Page {
  components?: Array<PageBlockComponent>;
  createdAt?: string;
  locale?: string;
  name?: string;
  publishedAt?: string;
  slug?: string;
  updatedAt?: string;
}

export interface PageBlockComponent {
  __component?: string;
  description?: string;
  id?: number;
  title?: string;
}
